/* eslint-disable import/prefer-default-export */
export const eligibilityData = {
  agentName: "Eligibility Review Agent",
  pageTitle: "Eligibility Review Agent",
  title: "Eligibility Review Agent",
  subtitle: "Agentic Apps",
  backPath: "/apps",

  entries: [
    {
      icon: "ER",
      text: 'You have been <strong>assigned case #3090</strong>.',
      meta: "2 hr ago",
      badge: "For Eligibility Review",
      links: [
        { label: "Ask Eligibility review Agent", href: "#open" },
        { label: "View Application", href: "#details" },
      ],
    },
    {
      icon: "ER",
      text: 'You have been <strong> assigned case #3023</strong>.',
      meta: "4 hr ago",
      badge: "For Eligibility Review",
      links: [
        { label: "Ask Eligibility review Agent", href: "#open" },
        { label: "View Application", href: "#details" },
      ],
    },
  ],

  actionItems: [
    {
      text: "Applications for Eligibility Review",
      type: "red",
      link: "#",
      linkText: "Assigned from Canopy",
      number: "16",
    },
  ],

};
